<template>
    <div style="padding-bottom: 40px">
        <CFTitle title="12. Riscuri"></CFTitle>
        <M3Warn type="yellow" text="Se vor descrie riscurile și măsurile corespunzătoare de prevenire / gestionare a acestora."></M3Warn>
        <validation-observer #default="{ invalid }" ref="responsabilProiect">
            <span class="display-none">{{ invalid }}</span>
            <validation-provider
                #default="{ errors }"
                rules="required"
            >
                <CFTextarea v-model="form.riscuri" :read-only="completed" :limit="1000"></CFTextarea>
                <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
        </validation-observer>
        <b-table v-if="riscuri && riscuri.length > 0" :items="riscuri" :fields="fields" style="margin-top: 10px">
            <template v-slot:cell(crt)="data">
                {{ Number(data.index) + 1 }}
            </template>
        </b-table>
        <M3Warn v-else type="red-warn" text="Riscurile pot fi adăugate din pagina "><template v-slot:link><router-link to="/aplicatii/m3-sketch/plan-de-afaceri" style="margin-left: 5px; color: #ffffff; font-weight: 600">Planul de afaceri</router-link></template></M3Warn>
        <p class="info-text">Info:  Pentru a modifica aceste informații vă rugăm să vizitați secțiunea: <router-link to="/aplicatii/m3-sketch/plan-de-afaceri">Plan de afaceri</router-link></p>
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            style="margin-bottom: -40px;"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTextarea from "./CFTextarea";
    import { BFormCheckbox, BTable, BFormTextarea } from "bootstrap-vue";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import CFTitle from "./CFTitle";
    import M3Warn from "../M3Warn";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';

    export default {
        name: "CFRiscuri",
        components: {
            CFTextarea,
            BFormCheckbox,
            BTable,
            ValidationProvider,
            ValidationObserver,
            BFormTextarea,
            CFTitle,
            M3Warn,
        },
        props: {
            data: {
                type: Object,
                default: null
            },
            m3GrantApplication: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                form: {
                    riscuri: ''
                },
                completed: null,
                riscuri: [],
                fields: [
                    {
                        key: 'crt',
                        label: 'Crt.',
                    },
                    {
                        key: 'identified',
                        label: 'Risc identificat',
                    },
                    {
                        key: 'monitoring',
                        label: 'Monitorizare de risc și răspuns/gestionare',
                    }
                ]
            }
        },
        computed: {
            isCompleted() {
                return this.$store.getters['finantare/progress'].includes('Riscuri');
            },
        },
        watch: {
            isCompleted: {
                handler() {
                    this.completed = this.isCompleted;
                },
                deep: true,
                immediate: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.riscuri){
                        this.form.riscuri = this.m3GrantApplication.riscuri.riscuri;
                    }
                },
                deep: true
            },
            data: {
                handler () {
                    if(this.data && this.data.m3_project && this.data.m3_project.business_plan_risks){
                        this.riscuri = this.data.m3_project.business_plan_risks.business_plan_risks
                    }
                },
                deep: true
            }
        },
        mounted() {
            if(this.data && this.data.m3_project && this.data.m3_project.business_plan_risks){
                this.riscuri = this.data.m3_project.business_plan_risks.business_plan_risks
            }
            if(this.m3GrantApplication && this.m3GrantApplication.riscuri){
                this.form.riscuri = this.m3GrantApplication.riscuri.riscuri;
            } else{
                this.form.riscuri = 'Departamentul de management al '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' stabileste normele de implementare si management al riscului. Astfel, vor exista protocoale de lucru privind monitorizarea riscurilor și gestionarea acestora prin răspunsuri rapide si obiective.'
            }
        },
        methods: {
            sendForm(){
                if(this.completed){
                    this.$refs.responsabilProiect.validate().then((e) => {
                        if (!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application', {riscuri: this.form})
                                .then(() => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$store.dispatch('finantare/addToProgress', 'Riscuri')
                                    this.$emit('savedData')
                                })
                        }
                    })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Riscuri')
                }
            }
        }
    }
</script>

<style scoped>
.subtitle{
  font-weight: bold;
}
</style>
